import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
import s from './customSnippet.module.css';

const mapStateToProps = ({
  page: { productType } = {},
  returnsSettings: { [productType]: { step_1_custom_snippet: customSnippetConfig } = {} } = {},
}) => ({
  config: customSnippetConfig,
});

const CustomSnippet = ({ config }) => {
  if (!config) {
    return null;
  }

  return (
    <div>
      <custom-snippet>
        {(config.components || []).map((component) => (
          <div className={cx(s.container, 'custom-snippet-container')}>
            {component.name === 'Divider' && <hr className="custom-snippet-divider" />}
            {component.name === 'Header' && (
              <h4 className={cx(s.header, 'custom-snippet-header')}>{component.text}</h4>
            )}

            {component.name === 'Paragraph' && (
              <p className={cx(s.paragraph, 'custom-snippet-paragraph')}>{component.text}</p>
            )}

            {component.name === 'Button' && (
              <a className="custom-snippet-button" href={component.url} target={component.target}>
                <button className={cx(s.button, 'narvar-btn-secondary custom-snippet-button')}>
                  <p className={cx(s.button_text, 'custom-snippet-button-text')}>
                    {component.text}
                  </p>
                </button>
              </a>
            )}
          </div>
        ))}
      </custom-snippet>
    </div>
  );
};

CustomSnippet.defaultProps = {
  config: undefined,
};

CustomSnippet.propTypes = {
  config: PropTypes.shape({
    components: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.oneOf(['Divider', 'Header', 'Paragraph', 'Button']),
      }),
    ),
  }),
};

export default connect(mapStateToProps)(CustomSnippet);
